import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PermissionService } from 'src/app/modules/wino-shared/services/permission.service';

@Component({
  selector: 'app-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.css']
})
export class GenericErrorComponent implements OnInit {

    errorMessage: string;
    constructor(private activatedRoute: ActivatedRoute, private permissionService: PermissionService) { }

    ngOnInit(): void {

        this.permissionService.updateTitleBarData("Qualcosa è andato storto...", false);

        if ( this.activatedRoute.snapshot.paramMap.has('message') ) {
            this.activatedRoute.params.subscribe(params => {
                this.errorMessage = params['message'];
                console.debug("Messaggio di errore: " + this.errorMessage);
            });
        }
    }

}
